import './_confirm.scss';
import './_confirm.dark-mode.scss';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Spinner from '../../Loaders/Spinner';

const ConfirmModal = ({ toggle, isOpen, bsSize, onConfirm, title, description, submitStyle, fetching, confirmBtnText, cancelBtnText, className }) => (
  <Modal show={isOpen} bsSize={bsSize} onHide={toggle} backdrop="static" className={classNames('modal__confirm', className)}>
    <Modal.Body>
      <div className="modal__confirm-title">{title}</div>
      <div className="modal__confirm-description">{description}</div>
      <div className="modal__confirm-actions">
        <Button bsStyle={submitStyle} onClick={onConfirm} disabled={fetching} type="button">
          {fetching && <Spinner />}
          <span>{confirmBtnText}</span>
        </Button>
        <Button onClick={toggle}>{cancelBtnText}</Button>
      </div>
    </Modal.Body>
  </Modal>
);

ConfirmModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  onConfirm: PropTypes.func,
  fetching: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),
  submitStyle: PropTypes.string,
  bsSize: PropTypes.string,
  confirmBtnText: PropTypes.string,
  cancelBtnText: PropTypes.string,
  className: PropTypes.string,
};

ConfirmModal.defaultProps = {
  bsSize: 'sm',
  title: 'Are you sure?',
  submitStyle: 'danger',
  confirmBtnText: 'Ok',
  cancelBtnText: 'Cancel',
};

export default ConfirmModal;
